export interface ConsoleConnectionSettingsState {
  host: string,
    port: string,
    password: string,
    path: string
}

export interface ConsoleState {
  consoleToken: string | null,
    consoleError: string,
    consoleLoading: boolean,
    connectionSettings: ConsoleConnectionSettingsState
}

const getInitialState = (): ConsoleState => ({
  consoleToken: null,
  consoleError: '',
  consoleLoading: false,
  connectionSettings: {
    host: '',
    port: '0',
    password: '',
    path: ''
  }
});

const consoleActions: CommonActionTree<ConsoleState> = {
  async FETCH_CONSOLE_SETTINGS({ commit, dispatch }, serverId: string): Promise<FetchResponse> {
    commit('LOADING');

    return dispatch('servers/GET_SERVER_CONSOLE', { id: serverId }, { root: true })
      .then((res) => {
        commit('SET_CONNECTION_SETTINGS', typeof window === 'undefined'
          ? res.data.url
          : `wss://${window.location.host}/websockify`
        );
        commit('SET_CONSOLE_TOKEN', res.data.token);
        commit('CLEAR_ERROR');
        commit('LOADED');
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR', err);
        commit('LOADED');
        throw err;
      });
  }
};

const consoleMutations: CommonMutationTree<ConsoleState> = {
  SET_CONSOLE_TOKEN(state, url) {
    state.consoleToken = url.split('=').pop();
  },

  SET_CONNECTION_SETTINGS(state, url) {
    const u = new URL(url);
    state.connectionSettings = { host: u.hostname, port: u.port, password: u.password, path: u.pathname.replace(/^\/+/g, '') };
  },

  SET_ERROR(state, res) {
    state.consoleError = res.message || '';
  },

  CLEAR_ERROR(state) {
    state.consoleError = '';
  },

  LOADING(state) {
    state.consoleLoading = true;
  },

  LOADED(state) {
    state.consoleLoading = false;
  },

  FLUSH_STATE(state) {
    Object.assign(state, getInitialState());
  }
};

const consoleGetters: CommonGetterTree<ConsoleState> = {
  consoleToken: _state => _state.consoleToken,
  connectionSettings: _state => _state.connectionSettings,
  consoleError: _state => _state.consoleError,
  consoleLoading: _state => _state.consoleLoading,
};

export default new class implements CommonStore<ConsoleState, unknown> {
  name = 'console';
  actions = consoleActions;
  mutations = consoleMutations;
  getters = consoleGetters;
  state = getInitialState();
}();
